import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React, { Component } from 'react';

import { translate } from 'react-i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import qs from 'qs';

import {
    setUserLoggedIn,
    completeTapLogin
} from '../../../actions/index';

//Common imports
import Loader from '../../Common/Loader';
// import {Icon} from '../../Common/Icon';

//Component imports
import AlertNotification from '../../Common/AlertNotification';
import CommunityLoginWidget from "../../_bit/tm-community-login-widget";
// import EmailLogin from '../EmailLogin';
// import ForgotPassword from '../forgotPassword';

//Helpers imports
import { gtmSend, getLocalizationI18 } from '../../../helpers';

//Others imports
import CONFIG from '../../../config';

//CSS imports
import cx from '../../../styles';
import Header from '../../Layout/Header';

let isCartAbandoned = true
class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {isActiveEmailLogin: false, isNavigatorDefine: false, isNewUser: false, tncAcceptance: true, showNotification: false, isLeftSlideOpen: false, drawerSource: 'hamburger'};
    }

    onEmailClick = (value) => {
        if(this.state.tncAcceptance){
            this.setState({isActiveEmailLogin: value, isNewUser: false});
        }
    }
    onCloseEmail = () => {
        this.setState({isActiveEmailLogin: false});
    }

    onGetStartedClick = () => {
        if(this.state.tncAcceptance){
            this.setState({isActiveEmailLogin: true, isNewUser: true});
            gtmSend('dynamic', 'Get Started', 'click', 'login page');
        }
    }

    handleBeforeUnload = () => {
        if(typeof smartech !== 'undefined' && isCartAbandoned) {
            if(this.props.userReducer.id) {
                smartech("dispatch", "CART_ABANDONMENT_REASON", 'Login');
            }
            smartech("dispatch", "cart_abandonment", 'Login');
        }
    }

    componentDidMount() {
        const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
        if(getParams['frtp'] && getParams['frtp'].includes('/buy/checkout/select-address/')) {
            isCartAbandoned = true
        } else {
            isCartAbandoned = false
        }
        if(typeof window != 'undefined'){
            window.addEventListener('beforeunload', this.handleBeforeUnload);
            if(navigator.userAgent.indexOf('Firefox') === -1 )
            {
                this.setState({
                    isNavigatorDefine: true
                })
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleOnChange = (e) => {
        this.setState({tncAcceptance: e.target.checked});
        this.props.toggleTncAcceptance(e.target.checked);
        if(e.target.checked){
            this.setState({showNotification: false});
            gtmSend('loginSignup_checkTnC', 'Login and Signup', 'Check TnC', '--');
        }else{
            this.setState({showNotification: true});
            gtmSend('loginSignup_uncheckTnC', 'Login and Signup', 'Uncheck TnC', '--');
            gtmSend('loginSignup_error_TnC', 'Login and Signup', 'Error TnC', '--');
        }
    }

    eventTracking = (event) => {
        if(event === 'tnc'){
            gtmSend('loginSignup_viewTnC', 'Login and Signup', 'View Terms & Conditions', '--');
        }else if('guideline'){
            gtmSend('loginSignup_viewCommunityGuidelines', 'Login and Signup', 'View Community Guidelines', '--');
        }
    }

    onFacebookLogin = () => {
        
        if(!this.state.tncAcceptance) {
            return;
        }

        if(document.getElementsByClassName(`facebook-btn`)[0] && document.getElementsByClassName(`facebook-btn`)[0].getElementsByClassName(`facebook-login-wrap`)[0] && document.getElementsByClassName(`facebook-btn`)[0].getElementsByClassName(`facebook-login-wrap`)[0].getElementsByTagName(`a`)[0])
        {
            document.getElementsByClassName(`facebook-btn`)[0].getElementsByClassName(`facebook-login-wrap`)[0].getElementsByTagName(`a`)[0].click();
        }
    }

    onGoogleLogin = () => {
        if(!this.state.tncAcceptance) {
            return;
        }
        
        if(document.getElementsByClassName(`google-btn`)[0] && document.getElementsByClassName(`google-btn`)[0].getElementsByTagName(`button`)[0]) {
            document.getElementsByClassName(`google-btn`)[0].getElementsByTagName(`button`)[0].click();
        }
    }
    
    checkIfActive = (path) => {
        const currentLocation = this.props.match.url;
        if (path == '/' && currentLocation == '/') {
            return "active";
        } else {
            return path != '/' && currentLocation.indexOf(path) > -1 ? "active" : "";
        }
    }

    handleLeftSlideOpen = (source = 'hamburger') => {
        if(!this.state.isLeftSlideOpen){
            gtmSend('dynamic', 'Hamburger', 'open', '');
        }
        else{
            gtmSend('dynamic', 'Hamburger', 'close', '');
        }
        this.setState({ isLeftSlideOpen: !this.state.isLeftSlideOpen, drawerSource: source });
    }

    onSuccess = (data) => {
        this.props.setUserLoggedIn(data)
            .then(() => {
                const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
                //const callbackUrl = `${getParams['frtp']} ${getParams['tap_var_cglr'] ? `?cglr=${getParams['tap_var_cglr']}` : ''}`;
                
                //create query string
                const arr = [];
                arr.push(`tm=${Math.random()}`); //Random string to clear caching of callback page
                if(getParams['tap_var_cglr']) {
                    arr.push(`cglr=${getParams['tap_var_cglr']}`)
                }
                if(getParams['frtp']) {
                    arr.push(`frtp=${getParams['frtp']}`)   
                }

                //if trying login to VIP or TAP_AWARDS and onbording will not 
                if(
                    getParams['frtp'] && 
                    (
                        getParams['frtp'].indexOf(process.env.REACT_APP_VIP_SITEHOST) !== -1 //if user is trying to login to VIP
                        ||
                        getParams['frtp'].indexOf(process.env.REACT_APP_TAP_AWARDS_SITEHOST) !== -1 //if user is trying to login to TAP_AWARDS
                        ||
                        getParams['frtp'].indexOf(process.env.REACT_APP_TAP_SHOP_SITEHOST) !== -1 //if user is trying to login to TAP_SHOP
                    )
                ) {
                    //this.props.onTapRedirectClick(callbackUrl);
                    isCartAbandoned = false
                    window.location.replace(`/login/success?${arr.join('&')}`);
                } 
                else if(data && data.response && data.response.step_register && data.response.step_register > 0){
                    //window.location = callbackUrl && callbackUrl.length > 0 && getParams['frtp'] ? `/onboarding?tm=${Math.random()}&frtp=${callbackUrl}` : `/onboarding?tm=${Math.random()}`;
                    window.location.replace(`/onboarding?${arr.join('&')}`)
                }
                else if(getParams['frtp']){   
                    //this.props.onTapRedirectClick(callbackUrl);
                    window.location.replace(`/login/success?${arr.join('&')}`);
                }
                else{
                    if( window.location.pathname === '/login') {
                        window.location = `/feed?tm=${Math.random()}`;
                    } else {
                        window.location = `/?tm=${Math.random()}`;
                    }
                }    
            });    
    }

    onLoginSuccess = (campaign) => {
        // let maxAge = 60*60*24*30*6;
        // let domain = process.env.REACT_APP_ENV == 'development' ? 'localhost' : '.theasianparent.com';
        // let cookieKey = this.props.configReducer.cookieKey;
        // document.cookie = `UR__${cookieKey}=${JSON.stringify({...this.props.userReducer, cookieCreatedAt: Date.now()})};max-age=${maxAge};domain=${domain};path=/`;
        //gtm
        let gtmEventSent = false;
        if(campaign && !this.props.appReducer.ifTapPollMode) {
            gtmEventSent = true;
            gtmSend('complete login', 'login', 'complete', campaign);
        }
        //if fb and mobile mode -- fix
        try {
            if(this.props.history.location.search.indexOf('vars') > -1) {
                let callbackUrl, choiceId;
                const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
                const state  = qs.parse(getParams['state'].replace('vars=', ''));
                const rurl = (state['rurl'] === '/login') ? '/' : state['rurl'];
                //if tap
                if(state['frtp']) {                
                    if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', state['utm_source']);
                    callbackUrl = `${state['frtp']} ${state['tap_var_cglr'] ? `?cglr=${state['tap_var_cglr']}` : ''}`;
                    this.props.setAppParams({tapCallbackUrl: callbackUrl});
                    this.props.setTapUrl(callbackUrl)
                    setTimeout(() => this.afterLoginRedirectFlow(this.props), 400);
                } else if(state['frpl']) {
                    // if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', 'tap-poll-signin');
                    callbackUrl = state['frpl'];
                    choiceId = state['frpId'];
                    this.props.setAppParams({ifTapPollMode: true, tapPollCallbackUrl: callbackUrl, tapPollChoiceId: choiceId});
                    setTimeout(() => this.afterLoginRedirectFlow(this.props), 400);
                } else if(state['redirect'] && state['redirect'] === 'edit') {
                    if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', 'email-edit');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props, `${this.props.configReducer.siteUrl}user/edit/${this.props.userReducer.slug}`), 400);
                } else {
                    if(!gtmEventSent && !this.props.appReducer.ifTapPollMode) gtmSend('complete login', 'login', 'complete', 'web');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props, rurl), 400);
                }
            } else {
                const params = qs.parse(this.props.history.location.search.replace('?', ''));
                if(params['redirect'] && params['redirect'] === 'edit') {
                    if(!gtmEventSent) gtmSend('complete login', 'login', 'complete', 'email-edit');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props, `${this.props.configReducer.siteUrl}user/edit/${this.props.userReducer.slug}`), 400);
                } else {
                    if(!gtmEventSent && !this.props.appReducer.ifTapPollMode) gtmSend('complete login', 'login', 'complete', 'web');
                    setTimeout(() => this.afterLoginRedirectFlow(this.props), 400);
                }                
            }

            //Set app lang and county on login
            // this.props.setAppParams({
            //     country: this.props.userReducer.country, 
            //     locale: this.props.userReducer.lang_code,
            // });

        } catch(e) {
            console.log('err', e);
            window.location = `/?tm=${Math.random()}`;
        }
                
    }

    afterLoginRedirectFlow = (props, fbMobileModeUrl='') => {
        //now logged in
        if(props.userReducer.id) {
            this.onModalClose();
            props.unsetAppParams({ifLoginFlowStarted: false});
            //decide redirect flow
            if(props.appReducer.ifTapPollMode) {
                if(props.appReducer.tapPollCallbackUrl) {
                    const url = (props.appReducer.socialLoginType && props.appReducer.socialLoginType === 'google')
                        ? props.appReducer.googleCallbackUrl
                        : props.appReducer.tapPollCallbackUrl;
                    props.completeTapPollLogin();
                    window.location = `${url}?tapPollChoiceId=${props.appReducer.tapPollChoiceId}&tm=${Math.random()}`;   
                }
            } else if(props.userReducer.is_new) {
                window.location = props.appReducer.tapCallbackUrl ? `/onboarding?tm=${Math.random()}&frtp=${props.appReducer.tapCallbackUrl}` : `/onboarding?tm=${Math.random()}`;
            } else if(props.appReducer.tapCallbackUrl) {
                // this.openTapModal();
                this.onTapRedirectClick();
            } else {
                if(fbMobileModeUrl) {
                    window.location = `${fbMobileModeUrl}?tm=${Math.random()}`;
                } else {
                    if(['inline', 'inlineBooth'].indexOf(this.props.mode) > -1) {
                        if( window.location.pathname === '/') {
                            window.location = `/feed?tm=${Math.random()}`;
                        } else{
                            window.location = `${window.location.pathname}?tm=${Math.random()}`;
                        }
                    } else {
                        if( window.location.pathname === '/login') {
                            window.location = `/feed?tm=${Math.random()}`;
                        } else {
                            window.location = `/?tm=${Math.random()}`;
                        }
                    }                    
                }//if redirect uri                
            }//if direct users
        }//if logged in     
        else{
            const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
            const callbackUrl = `${getParams['frtp']} ${getParams['tap_var_cglr'] ? `?cglr=${getParams['tap_var_cglr']}` : ''}`;
            if(callbackUrl && callbackUrl.length > 0 && getParams['frtp']){
                this.props.onTapRedirectClick(callbackUrl);
            }else{
                if( window.location.pathname === '/login') {
                    window.location = `/feed?tm=${Math.random()}`;
                } else {
                    window.location = `/?tm=${Math.random()}`;
                }
            }
        }   
    }

    render() {
        const {t} = this.props;

        const getParams = qs.parse(this.props.history.location.search.replace('?', ''));
        let loginHeaderLogoConfig = {
          url: generateAssetCdnUrl(
            "parenttown-prod/community/login-signup-assets",
            "tap_logo.png",
          ),
          mobileDimension: [40, 40],
          desktopDimension: [60, 60],
        };

        let isShowGoogleLoginButton = true;
        if(getParams['frtp'] && getParams['frtp'].indexOf(process.env.REACT_APP_TAP_AWARDS_SITEHOST) !== -1) {
            // if frtp is awards, use tap awards logo on login header.
            switch (this.props.appReducer.country) {
                case "id":
                    loginHeaderLogoConfig = {
                        url: generateAssetCdnUrl(
                            "tap-awards/wp-content/uploads/2024/06",
                            "tap-awards_Logo-onlyID-300x97.png",
                        ),
                        desktopDimension: [170, 44],
                        mobileDimension: [130, 33],
                    };
                    break;
                default:
                    isShowGoogleLoginButton = false;
            }
        }
        
        return (
            <div className={cx(`login-page-wrapper`)}>
                <Header 
                    history={this.props.history}
                    userReducer={this.props.userReducer}
                    appReducer={this.props.appReducer} 
                    configReducer={this.props.configReducer}
                    postReducer={this.props.postReducer}
                    match={this.props.match}
                    handleLeftSlideOpen={this.handleLeftSlideOpen}
                    isLeftSlideOpen={this.state.isLeftSlideOpen}
                    drawerSource={this.state.drawerSource}
                    page={'LoginPage'}
                    isMobile={this.props.isMobile}
                    logoConfig={loginHeaderLogoConfig}
                />

                <div className={cx("login-page")}>
                    {this.state.showNotification && <AlertNotification modal={false} t={t}/>}

                    <div className={cx(`left-section`)}>

                    <CommunityLoginWidget
                            user={this.props.appReducer} 
                            SiteConfig={CONFIG} 
                            onSuccess={this.onSuccess}
                            translation={getLocalizationI18(this.props.t)}
                            emailWidgetShowAsModal={true}
                            showMobileLogin={true}
                            enabledCountries={['th']}
                            isShowGoogleLoginButton={isShowGoogleLoginButton}
                        />
                        {/* <div className={cx(`login-option-wrapper`)}>
                            <h1>
                                Get expert-led tips and connect with other parents
                            </h1>
                            <div className={`button-wrapper`}>
                                <div className={cx(`social-login`)}>
                                    <div className={cx(`facebook-btn ${this.state.tncAcceptance ? '' : 'disabled-btn'}`)} onClick={ () => this.onFacebookLogin()}>
                                        <FacebookLoginComponent />
                                        <Icon name="facebook-icon"/>
                                        {
                                            this.props.isMobile
                                            ?
                                            `Facebook`
                                            :
                                            `Continue with Facebook`
                                        }
                                    </div>

                                    <div className={cx(`google-btn ${this.state.tncAcceptance ? '' : 'disabled-btn'}`)} onClick={ () => this.onGoogleLogin()}>
                                        <GoogleLoginComponent />
                                        <Icon name="google-icon"/>
                                        {
                                            this.props.isMobile
                                            ?
                                            `Google`
                                            :
                                            `Continue with Google`
                                        }
                                    </div>
                                </div>

                                <div className={`email-login-btn ${this.state.tncAcceptance ? '' : 'disabled-btn'}`} onClick={ () => console.log(`email click`)}>
                                    <span>
                                        <Icon name="login-email-icon"/>
                                        {
                                            this.props.isMobile
                                            ?
                                            `Email`
                                            :
                                            `Continue with Email`
                                        }
                                    </span>
                                </div>
                            </div>

                            <div className={cx('acceptance-wrap')}>
                                <input id="accept-input" checked={this.state.tncAcceptance} onChange={e => {this.handleOnChange(e)}} type="checkbox" />
                                <div className={cx('text-wrap')}>{t('tncAcceptance')} <a href='/privacy' onClick={()=>this.eventTracking('tnc')} target="_blank">{t('tnc')}</a> {t('and')} <a href='/community-guideline' onClick={()=>this.eventTracking('guideline')} target="_blank">{t('guidelines')}</a> </div>
                            </div>
                        </div> */}

                    </div>

                    <div className={cx("right-section", CONFIG['region']['region'])}>
                        <img src={`${generateAssetCdnUrl("parenttown-prod/community/login-signup-assets", "login_page_desktop.png")}`} loading="lazy" at="parenting image"/>
                    </div>

                    {/* <div className={cx("right-sec")}>
                        {
                            this.state.isActiveEmailLogin && 
                            <EmailLogin
                                onEmailLogin={this.props.onEmailLogin}
                                onCloseEmail={this.onCloseEmail}
                                emailCheck={this.props.emailCheck}
                                onForgotPassword={this.props.onForgotPassword}
                                isNewUser={this.state.isNewUser}
                                tncAcceptance={this.state.tncAcceptance}
                                isLoginPage={true} />
                        }
                        <div className={cx("login-section")}>

                            {
                                this.props.ifTapPoll
                                ?
                                    ""
                                :
                                    <div className={cx('ls-top')}>
                                        <h1>{t('login_main_title')}</h1>
                                        <p>{t('login_quality_answers')}</p>
                                    </div>

                            }
                            <div className={cx("ls-body")}>
                                <h2>{this.props.ifTapPoll ? t('login_vote_using') : t('login_with')}</h2>

                                <div className={cx('main-section', (this.props.urlParams.indexOf("vars") > -1 && 'hide'))}>
                                    <div className={cx("button-wrap")}>
                                        {
                                            this.props.socialLoginButtons.map((Button, i) => {
                                                return <Button key={i} />;
                                            })
                                        }
                                        <div className={cx('email-icon')} onClick={() => this.onEmailClick(true)}>
                                            <Icon name="email-icon" />
                                        </div>
                                    </div>
                                    <div>{t('or')}</div>
                                    <div className={cx('get-started-btn')} onClick={this.onGetStartedClick}>
                                        <span>{t('get_started')}</span>
                                        <Icon name="right-arrow-btn" />
                                    </div>
                                </div>

                                <div className={cx((this.props.urlParams.indexOf("vars") === -1) && 'hide')}>{t('login_redirecting')}</div>                                

                                <div className={cx('acceptance-wrap')}>
                                    <input id="accept-input" checked={this.state.tncAcceptance} onChange={e => {this.handleOnChange(e)}} type="checkbox" />
                                    <p className={cx('text-wrap')}>{t('tncAcceptance')} <a href='/privacy' onClick={()=>this.eventTracking('tnc')} target="_blank">{t('tnc')}</a> {t('and')} <a href='/community-guideline' onClick={()=>this.eventTracking('guideline')} target="_blank">{t('guidelines')}</a> </p>
                                </div>
                            </div>
                        </div>  */}
                    </div>
                    <div className={cx("login-footer-container", this.props.ifTapPoll && 'hide')}>
                        <div className={cx("footer-left-text")}>
                            <p>{t('login_footer_title')}</p>
                        </div>
                        <div className={cx("footer-country-flag")}>
                            <div className={cx("flag-icons")}>
                                <div>
                                    <em className={cx("flag-icons-sprite flag-singapore")}></em>
                                    <p>Singapore</p>
                                </div>
                            </div>
                            <div className={cx("flag-icons")}>
                                <div>
                                    <em className={cx("flag-icons-sprite flag-philippines")}></em>
                                    <p>Philippines</p>
                                </div>
                            </div>
                            <div className={cx("flag-icons")}>
                                <div>
                                    <em className={cx("flag-icons-sprite flag-indonesia")}></em>
                                    <p>Indonesia</p>
                                </div>
                            </div>
                            <div className={cx("flag-icons")}>
                                <div>
                                    <em className={cx("flag-icons-sprite flag-thailand")}></em>
                                    <p>Thailand</p>
                                </div>
                            </div>
                            <div className={cx("flag-icons")}>
                                <div>
                                    <em className={cx("flag-icons-sprite flag-malaysia")}></em>
                                    <p>Malaysia</p>
                                </div>
                            </div>
                            <div className={cx("flag-icons")}>
                                <div>
                                    <em className={cx("flag-icons-sprite flag-vietnam")}></em>
                                    <p>Vietnam</p>
                                </div>
                            </div>
                        </div>
                    </div>
                {/* </div> */}
                                
                {this.props.children}

                {this.props.isLoading && <Loader />}
            </div>
        );
    }
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setUserLoggedIn,
        completeTapLogin
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(LoginPage));
